import { render, staticRenderFns } from "./TabUserKYC.vue?vue&type=template&id=1ba91c9d"
import script from "./TabUserKYC.vue?vue&type=script&lang=js"
export * from "./TabUserKYC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports